import { completeEmailVerification } from "./api/auth.api";
import { ApiError } from "@/lib/api/client";

export type EmailVerificationState =
  "missing" | "verified" | "invalid" | "expired" | "used" | "superseded" | "failed";

let capturedToken: string | null = null;

export function captureEmailVerificationToken(): void {
  const pathname = window.location.pathname.replace(/\/+$/, "") || "/";
  if (pathname !== "/verify-email" || window.location.hash.length === 0) {
    return;
  }

  const fragment = window.location.hash.slice(1);
  window.history.replaceState(
    window.history.state,
    "",
    `${window.location.pathname}${window.location.search}`,
  );
  const token = new URLSearchParams(fragment).get("token");
  capturedToken = token && token.length > 0 ? token : null;
}

export function takeCapturedEmailVerificationToken(): string | null {
  const token = capturedToken;
  capturedToken = null;
  return token;
}

export async function loadEmailVerification(): Promise<EmailVerificationState> {
  captureEmailVerificationToken();
  const token = takeCapturedEmailVerificationToken();
  if (!token) {
    return "missing";
  }

  try {
    await completeEmailVerification(token);
    return "verified";
  } catch (error) {
    if (error instanceof ApiError) {
      if (error.code === "verification_token_invalid") return "invalid";
      if (error.code === "verification_token_expired") return "expired";
      if (error.code === "verification_token_used") return "used";
      if (error.code === "verification_token_superseded") return "superseded";
      if (error.code === "verification_token_required") return "missing";
    }
    return "failed";
  }
}
